import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const tileAccents = {
  blue: "bg-blue-50 text-blue-600",
  green: "bg-green-50 text-green-600",
  red: "bg-red-50 text-red-600",
  violet: "bg-violet-50 text-violet-600",
  amber: "bg-amber-50 text-amber-600",
  teal: "bg-teal-50 text-teal-600",
  sky: "bg-sky-50 text-sky-600",
  rose: "bg-rose-50 text-rose-600",
  gray: "bg-gray-100 text-gray-600",
}

const StatTile = ({ label, value, hint, icon, accent = "blue", sub }) => (
  <div
    className="flex items-center gap-3 bg-white rounded-xl px-4 py-3 flex-1 min-w-[190px] shadow-sm text-left border border-gray-200"
    title={hint}
  >
    <div
      className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${tileAccents[accent]}`}
    >
      <FontAwesomeIcon className="w-4 h-4" icon={icon} />
    </div>
    <div className="min-w-0">
      <div className="text-2xl font-bold text-gray-900 leading-none tabular-nums">
        {(value ?? 0).toLocaleString()}
      </div>
      <div className="text-[10px] font-semibold uppercase tracking-wider text-gray-500 mt-1">
        {label}
      </div>
      {sub && (
        <div className="text-sm font-bold text-gray-600 mt-0.5">{sub}</div>
      )}
    </div>
  </div>
)

export default StatTile
